import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import styled from "@emotion/styled";
import { RoutesPath } from "@ui/navigation/routes";
import {
	ProfessionalInformationValidationSteps,
	progressionStepsData,
} from "@ui/pages/validate-professional-information/components/register-progression-bar";
import { colors } from "@ui/style/colors";
import { isNotNil } from "@utils/assert";
import React from "react";
import { AppLogo } from "@ui/components/common/app-logo";

interface ShortRegisterProgressionBarProps {
	step?: ProfessionalInformationValidationSteps;
}

export const ShortRegisterProgressionBar = ({ step: currentStep }: ShortRegisterProgressionBarProps): JSX.Element => {
	const { format } = useI18n();
	const currentStepLabel = progressionStepsData.find(step => step.step === currentStep)?.label;
	const navigate = useNavigate();
	const navigateToLogin = async () => {
		navigate(RoutesPath.Login);
	};

	return (
		<Container>
			<StyledAppLogo height={25} width={96} onClick={() => navigateToLogin()} />
			{isNotNil(currentStep) && (
				<StepsContainer>
					<DotsContainer>
						{progressionStepsData.map(step => (
							<Dot key={step.step} active={step.step <= currentStep} />
						))}
					</DotsContainer>
					{isNotNil(currentStepLabel) && <Label className="p-size-xs-semi-bold">{format(currentStepLabel)}</Label>}
				</StepsContainer>
			)}
		</Container>
	);
};

const Container = styled.div`
	height: 80px;
	border-bottom: 1px solid ${colors.primary25};
	display: flex;
	justify-content: center;
	align-items: center;
`;

const StyledAppLogo = styled(AppLogo)`
	cursor: pointer;
	position: absolute;
	left: 10px;
	top: 20px;
`;

const StepsContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const DotsContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
`;

const Dot = styled.div<{ active: boolean }>`
	height: 8px;
	width: 8px;
	border-radius: 100%;
	background-color: ${({ active }) => (active ? colors.primary : colors.grey25)};
`;

const Label = styled.div`
	white-space: nowrap;
	margin-top: 8px;
	color: ${colors.primary};
`;
